import React, { useEffect, useState } from "react";
import UpgradeNudge from "./UpgradeNudge";

/**
 * Listens for global 'geovinum:upgrade-nudge' events fired by the axios
 * interceptor when the API returns 402/403/429 with an upgrade signal,
 * and renders a contextual UpgradeNudge modal.
 *
 * Mount once at app root inside <Layout>.
 */
export default function UpgradeNudgeListener() {
  const [nudge, setNudge] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      const d = e?.detail || {};
      // De-bounce: don't stack — replace any existing
      setNudge({
        featureKey: d.featureKey || null,
        reason: d.reason || "locked",
        message: d.message || null,
      });
    };
    window.addEventListener("geovinum:upgrade-nudge", handler);
    return () => window.removeEventListener("geovinum:upgrade-nudge", handler);
  }, []);

  if (!nudge) return null;
  return (
    <UpgradeNudge
      variant="modal"
      featureKey={nudge.featureKey}
      reason={nudge.reason}
      message={nudge.message}
      onClose={() => setNudge(null)}
    />
  );
}
